module.exports = __webpack_public_path__ + "img/anabelHoult.578d7585.gif";